import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import dayjs from 'dayjs'
import './hotels.css'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { Link, useNavigate } from "react-router-dom";
import { Button, Drawer, Box, Stack, TextField, Autocomplete, Menu } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Slider from '@mui/material/Slider';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import { getAminites, getHotels, hotelBooking, getHotelTypes } from '../../api/hotel'
import { ToastContainer, toast } from 'react-toastify'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { city } from '../../api/airport'
import { getImageUrl } from '../../utils/imageUrl'
// -------------------------------------------------

function valuetext(value) {
  return `${value}°C`;
}

const Hotels = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openB = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [hotels, setHotels] = useState([])
  const [hotel, setHotel] = useState([])
  const getHotel = async () => {
    const resp = await getHotels()
    setHotel(resp?.data)
    setHotels(resp?.data)
  }
  useEffect(() => {
    getHotel()
  }, [])

  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const notify = (message) => toast(message)
  const prices = hotel?.map(item => item.price);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);

  const [value, setValue] = React.useState([minPrice, maxPrice]);
  const handleChange = async (event, newValue) => {
    setValue(newValue);

    const resp = await getHotels()

    const filter = resp?.data?.filter((items) => {
      return items?.price > newValue[0] && items?.price < newValue[1]
    })

    setHotels(filter)
  };

  const [rating, setRating] = React.useState('');
  const [rating1, setRating1] = React.useState('');
  const [name, setName] = useState('')
  const [cit, setCit] = useState('')
  const [aminities, setAminities] = useState('')
  const [hotelType, setHotelType] = useState('')

  // State for hotel types fetched from API
  const [hotelTypes, setHotelTypes] = useState([])

  // State to track selected ratings for active styling
  const [selectedCustomerRating, setSelectedCustomerRating] = useState(null)
  const [selectedStarRating, setSelectedStarRating] = useState(null)
  const [selectedAmenity, setSelectedAmenity] = useState(null)

  // Fetch hotel types from API on mount
  useEffect(() => {
    const fetchHotelTypes = async () => {
      try {
        const resp = await getHotelTypes()
        if (resp?.data) {
          // Transform API response to dropdown format with emojis
          const hotelTypeOptions = resp.data.map(type => ({
            label: `${getHotelTypeEmoji(type.name)} ${type.name}`,
            value: type._id,
            name: type.name
          }))
          setHotelTypes(hotelTypeOptions)
        }
      } catch (error) {
        console.error('Error fetching hotel types:', error)
      }
    }
    fetchHotelTypes()
  }, [])

  /**
   * Returns an appropriate emoji for each hotel type
   * @param {string} typeName - Name of the hotel type
   * @returns {string} - Emoji representing the hotel type
   */
  const getHotelTypeEmoji = (typeName) => {
    const emojiMap = {
      'Budget Hotel': '💵',
      'Economy Hotel': '🏷️',
      'Standard Hotel': '🏨',
      'Luxury Hotel': '✨',
      'Boutique Hotel': '🎀',
      'Business Hotel': '💼',
      'Heritage Hotel': '🏛️',
      'Resort': '🌴',
      'Beach Resort': '🏖️',
      'Hill Resort': '⛰️',
      'Spa & Wellness Resort': '🧘',
      'Motel': '🚗',
      'Lodge': '🏡',
      'Guest House': '🏠',
      'Homestay': '🏡',
      'Bed & Breakfast': '🍳',
      'Hostel': '🛏️',
      'Service Apartment': '🏢',
      'Villa': '🏰',
      'Cottage': '🛖',
      'Farm Stay': '🌾',
      'Palace Hotel': '👑',
      'Houseboat': '🚤',
      'Camp / Glamping': '⛺',
      'Dharamshala': '🕉️',
      'Ashram Stay': '🧘‍♂️',
      'Corporate Guest House': '🏢',
      'Other': '🏨'
    }
    return emojiMap[typeName] || '🏨'
  }

  /**
   * Clears all applied filters and resets the hotel list
   */
  const clearAllFilters = async () => {
    setCit('')
    setHotelType('')
    setSelectedItems([])
    setSelectedCustomerRating(null)
    setSelectedStarRating(null)
    setSelectedAmenity(null)
    setValue([minPrice, maxPrice])
    const resp = await getHotels()
    setHotels(resp?.data)
  }

  const tomorrow = dayjs()
  const [hotelDetail, setHotelDetail] = useState({
    hotel: '',
    checkIn: '',
    checkOut: '',
    roomCount: 0,

    adultCount: 0,
    childCount: 0
  })


  const [nHotel, setNHotel] = useState('')

  const hotelData = hotels.map((item) => ({ label: item?.name, value: item?.name }))

  function checkEmptyKeys(obj) {
    for (const key in obj) {
      if (obj[key] === "") {
        return true;
      }
    }
    return false;
  }

  useEffect(() => {
    if (nHotel !== '') {
      const tempData = hotels.find((items) => {
        return items.name === nHotel
      })
      setHotelDetail({
        ...hotelDetail,
        hotel: tempData?._id
      })
    }
  }, [nHotel])

  const [childCount, setChildCount] = useState(0)
  const [adultCount, setAdultCount] = useState(0)

  const [roomCount, setRoomCount] = useState(0)

  useEffect(() => {
    if (adultCount === 0) {
      setHotelDetail({
        ...hotelDetail,
        adultCount: adultCount
      })
    } else {
      setHotelDetail({
        ...hotelDetail,
        adultCount: adultCount
      })
    }
  }, [adultCount])



  useEffect(() => {
    if (roomCount === 0) {
      setHotelDetail({
        ...hotelDetail,
        roomCount: 0
      })
    } else {
      setHotelDetail({
        ...hotelDetail,
        roomCount: roomCount
      })
    }
  }, [roomCount])

  useEffect(() => {
    if (childCount === 0) {
      setHotelDetail({
        ...hotelDetail,

        childCount: 0

      })
    } else {
      setHotelDetail({
        ...hotelDetail,

        childCount: childCount

      })
    }
  }, [childCount])
  const token = localStorage.getItem('token')
  const submit = async () => {
    if (token) {
      if (hotelDetail.hotel === '') {
        notify('Hotel is required')
      } else if (hotelDetail.adultCount === 0) {
        notify('Adult Count is required')
      } else if (hotelDetail.roomCount === 0) {
        notify('Room Count is required')
      } else if (hotelDetail.checkIn === '') {
        notify('Check in is required')
      } else if (hotelDetail.checkOut === '') {
        notify('Check out is required')
      }
      else {
        localStorage.setItem('hotelDetails', JSON.stringify(hotelDetail))
        navigate(`/hotelDetail/${hotelDetail.hotel}`)
      }
    } else {
      notify('Please Login for booking')
    }
  }

  useEffect(() => {
    localStorage.removeItem('hotelDetails')
  }, [])
  const [ami, setAmi] = useState([])
  const amini = async () => {
    const resp = await getAminites()
    setAmi(resp.data.docs)
  }
  useEffect(() => {
    amini()
  }, [])
  const [selectedItems, setSelectedItems] = useState([]);

  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prevSelectedItems) => {
      if (prevSelectedItems.some(selected => selected._id === itemId)) {
        return prevSelectedItems.filter(selected => selected._id !== itemId);
      } else {
        return [...prevSelectedItems, { _id: itemId }];
      }
    });
  };
  console.log(selectedItems)

  const am = async () => {
    if (selectedItems.length > 0) {
      const resp = await getHotels({ aminities: selectedItems })
      setHotels(resp?.data)
    } else {
      const resp = await getHotels()
      setHotels(resp?.data)
    }

  }

  useEffect(() => {
    am()
  }, [selectedItems])
  const [cities, setCities] = useState([])

  const getCities = async () => {
    const resp = await city()
    setCities(resp.data)
  }

  useEffect(() => {
    getCities()
  }, [])
  const City = cities?.map((items) => ({ label: items?.name, value: items?.name }))


  const marks = [
    {
      value: minPrice,
      label: '',
    },
    {
      value: maxPrice,
      label: '',
    },
  ];


  return (
    <>
      <Header />
      <section className=''>
        <div className='container'>
          <div className="detailTitle">
            <div className="row">
              <div className="col-md-10 mx-auto text-center">
                <h1 className="text-dark display-3 pt-sm-5 my-5">Book Your Hotel Now</h1>
              </div>
            </div>
            <Box
              sx={{
                backgroundColor: '#fff',
                padding: '15px 20px',
                borderRadius: '10px',
              }}
            >
              <div className='row'>
                <div className='col-md-6 col-lg-3'>
                  <Autocomplete
                    sx={{ margin: '6px 0 0 0' }}
                    disablePortal
                    id="combo-box-demo"
                    options={hotelData}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }
                    }
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    value={nHotel}
                    onChange={(e, newValue) => {
                      console.log(newValue)
                      setNHotel(newValue.value)
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Hotel" />}
                  />
                </div>
                <div className='col-md-6 col-lg-2 daeSection'>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <DatePicker placeholder="Select Date" label="Check in"
                        minDate={tomorrow}
                        value={hotelDetail.checkIn}
                        onChange={(newValue) => {
                          const date = new Date(newValue['$d']);
                          setHotelDetail({
                            ...hotelDetail,
                            checkIn: date
                          })
                        }}

                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className='col-md-6 col-lg-2 daeSection'>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <DatePicker placeholder="Select Date" label="Check out"
                        value={hotelDetail.checkOut}
                        minDate={dayjs(hotelDetail?.checkIn)}
                        onChange={(newValue) => {
                          const date = new Date(newValue['$d']);
                          setHotelDetail({
                            ...hotelDetail,
                            checkOut: date
                          })
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </div>
                <div className='col-md-6 col-lg-3 hotF'>
                  <div className='guestBox w-100'>
                    <Button
                      id="basic-button"
                      aria-controls={openB ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openB ? 'true' : undefined}
                      onClick={handleClick}
                      className='guestBtn'
                    >
                      {hotelDetail.adultCount > 0 && `Adult Count ${hotelDetail.adultCount}`} {' '}

                      {hotelDetail.roomCount > 0 && `Room Count ${hotelDetail.roomCount}`}
                      {hotelDetail.adultCount === 0 && hotelDetail.roomCount === 0 && `Guest and room Count`}


                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openB}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem className='muiB'>
                        <ul class="dropdown-menu guest-selector-dropdown show" style={{ position: 'absolute', inset: '0px auto auto 0px', margin: '0px', }} data-popper-placement="bottom-start">
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Adults</h6>
                              <small>Ages 13 or above</small>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (adultCount > 0) {
                                    setAdultCount(adultCount - 1)
                                  } else {
                                    setHotelDetail({
                                      ...hotelDetail,
                                      adultCount: 0
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 adults">{adultCount}</h6>
                              <button
                                onClick={() => {

                                  setAdultCount(adultCount + 1)

                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="dropdown-divider"></li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Room Count</h6>
                              <small>Max room 8</small>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (roomCount > 0) {
                                    setRoomCount(roomCount - 1)
                                  } else {
                                    setHotelDetail({
                                      ...hotelDetail,
                                      roomCount: 0
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 rooms">{roomCount}</h6>
                              <button
                                onClick={() => {

                                  if (roomCount < 8) {
                                    setRoomCount(roomCount + 1)
                                  }

                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="dropdown-divider"></li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Child Count</h6>
                              <small>Ages 13 or above</small>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (childCount > 0) {
                                    setChildCount(childCount - 1)
                                  } else {
                                    setHotelDetail({
                                      ...hotelDetail,
                                      childCount: 0
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 rooms">{childCount}</h6>
                              <button
                                onClick={() => {

                                  setChildCount(childCount + 1)

                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0" type="button">
                                <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 fa-fw">
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                {/* <div className='col-md-6 col-lg-3'>
                  <TextField
                    sx={{ margin: '6px 0 0 0', width: '100%' }}
                    placeholder='Room Count'
                    label='Room Count'
                    type='number'
                    value={hotelDetail.roomCount}
                    onChange={(e) => {
                      setHotelDetail({
                        ...hotelDetail,
                        roomCount: e.target.value
                      })
                    }}
                  />
                </div>

                <div className='col-md-6 col-lg-3'>
                  <TextField
                    type='number'
                    sx={{ margin: '20px 0 0 0', width: '100%' }}
                    placeholder='Guest Count'
                    label='Guest Count'
                    value={hotelDetail.guestCount}
                    onChange={(e) => {
                      setHotelDetail({
                        ...hotelDetail,
                        guestCount: e.target.value
                      })
                    }}
                  />
                </div>
                <div className='col-md-6 col-lg-3'>
                  <TextField
                    sx={{ margin: '20px 0 0 0', width: '100%' }}
                    placeholder='Adult Count'
                    type='number'
                    label='Adult Count'
                    value={hotelDetail.adultCount}
                    onChange={(e) => {
                      setHotelDetail({
                        ...hotelDetail,
                        adultCount: e.target.value
                      })
                    }}
                  />
                </div>
                <div className='col-md-6 col-lg-3'>
                  <TextField
                    sx={{ margin: '20px 0 0 0', width: '100%' }}
                    placeholder='Child Count'
                    label='Child Count'
                    value={hotelDetail.childCount}
                    onChange={(e) => {
                      setHotelDetail({
                        ...hotelDetail,
                        childCount: e.target.value
                      })
                    }}
                  />
                </div> */}
                <div className='col-md-6 col-lg-2'>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100%',
                    }}
                  >
                    <button
                      onClick={submit}
                      className="btn btn-dark mt-2 px-5" >
                      Search
                    </button>
                  </Box>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </section>
      <section className='hotelsPage'>
        <div className='container'>
          <div className='filter'>
            <Button className='filterBtn' onClick={toggleDrawer(true)}><i className="fa-solid fa-filter"></i> Show Filter</Button>
            {/* <h5>150 Hotels</h5> */}
            <Drawer open={open} onClose={toggleDrawer(false)}>
              {/* Filter Drawer Header with gradient styling */}
              <Box className='filterDra filterDrawerHeader'>
                <h3>🔍 Apply Filters</h3>
                <button
                  className='clearFiltersBtn'
                  onClick={clearAllFilters}
                >
                  ✨ Clear All
                </button>
              </Box>

              <Box className="filterBg filterContent" sx={{ width: 350, p: 2 }} role="presentation">

                {/* City Filter Section */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>🏙️ City</label>
                  <Autocomplete
                    className="filterAutocomplete"
                    sx={{ margin: '6px 0 0 0' }}
                    size='small'
                    disablePortal
                    id="city-filter"
                    options={City}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }}
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    value={cit}
                    onChange={async (event, newValue) => {
                      if (newValue !== null) {
                        setCit(newValue.value)
                        if (newValue.value !== '') {
                          const resp = await getHotels({ city: newValue.value })
                          setHotels(resp.data)
                        } else {
                          const resp = await getHotels()
                          setHotels(resp.data)
                        }
                      } else {
                        return;
                      }
                    }}
                    renderInput={(params) => <TextField {...params} placeholder="Select City" />}
                  />
                </Stack>

                {/* Price Range Filter Section */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>💰 Price Range</label>
                  <div className="priceRangeDisplay">
                    <span>₹{value[0]}</span>
                    <span>₹{value[1]}</span>
                  </div>
                  <Slider
                    className="priceSlider"
                    marks={marks}
                    step={10}
                    value={value}
                    valueLabelDisplay="auto"
                    min={minPrice}
                    max={maxPrice}
                    onChange={handleChange}
                  />
                </Stack>
                {/* Customer Rating Filter Section */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>😊 Customer Rating</label>
                  <ul className="ratingButtons">
                    {[1, 2, 3, 4, 5].map((ratingNum) => (
                      <li
                        key={`customer-${ratingNum}`}
                        onClick={async () => {
                          setSelectedCustomerRating(selectedCustomerRating === ratingNum ? null : ratingNum)
                          if (selectedCustomerRating !== ratingNum) {
                            const resp = await getHotels({ customerRating: ratingNum })
                            setHotels(resp?.data)
                          } else {
                            const resp = await getHotels()
                            setHotels(resp?.data)
                          }
                        }}
                        className={`ratingBtn ${selectedCustomerRating === ratingNum ? 'active' : ''}`}
                      >
                        {ratingNum} {'⭐'.repeat(ratingNum > 3 ? 1 : 0)}
                      </li>
                    ))}
                  </ul>
                </Stack>
                {/* Star Rating Filter Section */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>⭐ Star Rating</label>
                  <ul className="ratingButtons starRatingButtons">
                    {[1, 2, 3, 4, 5].map((starNum) => (
                      <li
                        key={`star-${starNum}`}
                        onClick={async () => {
                          setSelectedStarRating(selectedStarRating === starNum ? null : starNum)
                          if (selectedStarRating !== starNum) {
                            const resp = await getHotels({ starRating: starNum })
                            setHotels(resp?.data)
                          } else {
                            const resp = await getHotels()
                            setHotels(resp?.data)
                          }
                        }}
                        className={`ratingBtn starBtn ${selectedStarRating === starNum ? 'active' : ''}`}
                      >
                        {starNum} ⭐
                      </li>
                    ))}
                  </ul>
                </Stack>

                {/* Hotel Type Filter Section - Using API data instead of hardcoded values */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>🏨 Hotel Type</label>
                  <Autocomplete
                    className="filterAutocomplete"
                    sx={{ margin: '6px 0 0 0' }}
                    size='small'
                    disablePortal
                    id="hotel-type-filter"
                    options={hotelTypes}
                    value={hotelType}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ""
                      }
                    }}
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) { return option.value === value.value } else {
                        return false
                      }
                    }}
                    onChange={async (event, newValue) => {
                      if (newValue !== null) {
                        // Store entire object to display label correctly
                        setHotelType(newValue)
                        if (newValue.value !== '') {
                          // Filter hotels by hotel type name from API
                          const resp = await getHotels({ hotelType: newValue.name || newValue.value })
                          setHotels(resp.data)
                        } else {
                          const resp = await getHotels()
                          setHotels(resp.data)
                        }
                      } else {
                        // Clear selection
                        setHotelType('')
                        const resp = await getHotels()
                        setHotels(resp.data)
                      }
                    }}
                    renderInput={(params) => <TextField {...params} placeholder="Select Hotel Type" />}
                  />
                </Stack>

                {/* Amenities Filter Section */}
                <Stack className="filterSection" sx={{ py: 1 }}>
                  <label className='filterLabel'>✨ Amenities</label>
                  <FormGroup
                    className="amenitiesGroup"
                    sx={{
                      flexDirection: 'column',
                    }}
                  >
                    {ami.map((items, index) => (
                      <FormControlLabel
                        className="amenityCheckbox"
                        key={items?._id}
                        control={
                          <Checkbox
                            checked={selectedAmenity === items?._id}
                            onChange={async (e) => {
                              if (e.target.checked) {
                                setSelectedAmenity(items?._id)
                                const resp = await getHotels({ amenitiesName: items?.name })
                                setHotels(resp?.data)
                              } else {
                                setSelectedAmenity(null)
                                const resp = await getHotels()
                                setHotels(resp?.data)
                              }
                            }}
                            sx={{
                              color: '#0d9488',
                              '&.Mui-checked': {
                                color: '#0d9488',
                              },
                            }}
                          />
                        }
                        label={`${items.name}`}
                      />
                    ))}

                  </FormGroup>
                </Stack>
                {/* <Stack sx={{ py: 1 }}>
                  <label className='pb-1'>Amenities</label>
                  <Autocomplete
                    size='small'
                    sx={{ margin: '6px 0 0 0' }}
                    multiple
                    id="combo-box-demo"
                    options={top100Films}
                    // value={aminities}
                    onChange={(event, newValue) => {
                      // setAminities(newValue)
                    }}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => <TextField {...params} placeholder="Select Amenities" />}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip label={option.label} {...getTagProps({ index })} />
                      ))
                    }
                  />
                </Stack> */}
                {/* <Stack sx={{ py: 1 }}>
                  <label className='pb-1'>Popular Filters</label>
                  <Autocomplete
                    size='small'
                    sx={{ margin: '6px 0 0 0' }}
                    disablePortal
                    id="combo-box-demo"
                    options={top100Films}
                    renderInput={(params) => <TextField {...params} placeholder="Select Option" />}
                  />
                </Stack> */}

                {/* <Stack sx={{ py: 1 }}>
                  <button className='btn btn-dark'>Apply Filter</button>
                </Stack> */}
              </Box>
            </Drawer>
          </div>
          <div className='row py-3'>
            {hotels?.map((items) => (

              <div key={items?._id} className="col-md-6 col-xl-4 py-2">
                <Link to={`/hotelDetail/${items?._id}`} >

                  <div className="card shadow p-2 pb-0 h-100 border-0" >
                    <div className='hotelsImage'>
                      <img src={getImageUrl(items?.images?.[0])} alt="Card-img" />
                    </div>
                    <div className="card-body px-3 pb-0">
                      <div className="d-flex justify-content-between mb-3 align-items-center">
                        <a aria-current="page" href="#!" className="router-link-active router-link-exact-active badge bg-dark text-white items-center">
                          <i className="fa-solid fa-star fa-fw me-2 text-warning"></i>
                          {items?.starRating}
                        </a>
                        {/* <a aria-current="page" href="#!" className="router-link-active router-link-exact-active h6 mb-0 z-index-2">
                          <i className="fa-solid fa-heart"></i>
                        </a> */}
                      </div>
                      <h5 className="card-title"><a href="#!" className="">{items?.name}</a></h5>
                      <ul className="nav nav-divider mb-2 mb-sm-3">
                        {items?.amenities[0] && <li className="nav-item">{items?.amenities[0]?.name} </li>}
                        {items?.amenities[1] && <li className="nav-item">{items?.amenities[1]?.name} </li>}
                        {items?.amenities[2] && <li className="nav-item">{items?.amenities[2]?.name} </li>}
                        {items?.amenities[3] && <li className="nav-item">{items?.amenities[3]?.name} </li>}


                      </ul>
                    </div>
                    <div className="card-footer py-2">
                      <div className="d-sm-flex justify-content-sm-between align-items-center">
                        <div className="d-flex align-items-center">
                          <h5 className="fw-normal text-success mb-0 me-1">₹ {items?.price}</h5>
                          <span className="mb-0 me-2">/day</span>
                        </div>
                        <div className="mt-2 mt-sm-0">
                          <a href={`/hotelDetail/${items?._id}`} className="btn btn-sm btn-primary-soft mb-0 w-100 items-center">
                            View Detail <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="ms-2"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path></svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>


                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Hotels